import { pick } from 'ramda';

export default pick([
  'name',
  'sandbox',
  'src',
  'srcdoc',
  'width',
  'height',
  'allowFullScreen',
]);
